/**
 * @generated SignedSource<<21958b72eedfdb14648a4c85dcca94f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ObjectivesPanelQuery$variables = {};
export type ObjectivesPanelQuery$data = {
  readonly viewer: {
    readonly myTeams: ReadonlyArray<{
      readonly archived: boolean;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"TeamLink_info">;
    }> | null;
  };
};
export type ObjectivesPanelQuery = {
  response: ObjectivesPanelQuery$data;
  variables: ObjectivesPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archived",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ObjectivesPanelQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "myTeams",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamLink_info"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ObjectivesPanelQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "myTeams",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b142a671bcc456e1cdfbc6e51553759f",
    "id": null,
    "metadata": {},
    "name": "ObjectivesPanelQuery",
    "operationKind": "query",
    "text": "query ObjectivesPanelQuery {\n  viewer {\n    myTeams {\n      id\n      archived\n      ...TeamLink_info\n    }\n    id\n  }\n}\n\nfragment TeamLink_info on Team {\n  id\n  title\n  archived\n  url\n}\n"
  }
};
})();

(node as any).hash = "03722fee0750dbed0245a0d75afaac87";

export default node;
